import { DiamondsListCard } from "./DiamondsListCard";

export default DiamondsListCard;
